import React, { useEffect, createElement } from 'react';
import { useLocation } from 'react-router-dom';
interface SEOProps {
  title?: string;
  description?: string;
  image?: string;
  article?: boolean;
}
export const SEO: React.FC<SEOProps> = ({
  title = 'Blue Rain Productions | Film & TV Producties',
  description = 'Van creatief idee tot perfecte uitvoering. Producer, locatiemanager en setmanager voor film, tv-series, videoclips en commercials.',
  image = 'https://uploadthingy.s3.us-west-1.amazonaws.com/jJy59TMDp1yB3h9h9tuSsL/LOGO_BLUEsmall.png',
  article = false
}) => {
  const location = useLocation();
  const baseUrl = 'https://bluerainproductions.nl';
  const currentUrl = `${baseUrl}${location.pathname}`;
  useEffect(() => {
    // Update canonical link
    let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = currentUrl;
    // Update page title
    document.title = title;
    // Update meta description
    let metaDescription = document.querySelector('meta[name="description"]') as HTMLMetaElement;
    if (metaDescription) {
      metaDescription.content = description;
    }
    // Update OG tags
    let ogTitle = document.querySelector('meta[property="og:title"]') as HTMLMetaElement;
    if (ogTitle) {
      ogTitle.content = title;
    }
    let ogDescription = document.querySelector('meta[property="og:description"]') as HTMLMetaElement;
    if (ogDescription) {
      ogDescription.content = description;
    }
    let ogUrl = document.querySelector('meta[property="og:url"]') as HTMLMetaElement;
    if (ogUrl) {
      ogUrl.content = currentUrl;
    }
    let ogImage = document.querySelector('meta[property="og:image"]') as HTMLMetaElement;
    if (ogImage) {
      ogImage.content = image;
    }
    let ogType = document.querySelector('meta[property="og:type"]') as HTMLMetaElement;
    if (ogType) {
      ogType.content = article ? 'article' : 'website';
    }
  }, [title, description, image, article, currentUrl]);
  return null;
};